export const analyticsDashboard = {
  // Common analytics card translations
  noHistoricalDataAvailable: "No historical data available",
  details: "Details",
  monthToDate: "Month-to-date",
  past12Months: "Past 12 months",
};
